import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_ME } from '../graphql/getMe';
import { Role } from '../__generated__/graphql';

export const useNavigateHome = () => {
  const navigate = useNavigate();
  const { data: me, loading: meLoading } = useQuery(GET_ME);

  const navigateHome = () => {
    if (!me && !meLoading) {
      return;
    }
    
    if (me?.getMe?.role === Role.Admin) {
      navigate('/admin');
    } else {
      navigate('/dashboard');
    }
  };

  return {
    navigateHome,
    isAdmin: me?.getMe?.role === Role.Admin
  };
}; 